import { Button } from '@mui/material'
import React from 'react'
import { openModalFn } from '../../../../../../utils/controllers/ModalController'

const ReturnForRevisionBtn = () => {
    const handleAction = () => {
        openModalFn['intermediate-drawer']({ type: 'return-for-revision' })
    }
    return (
        <Button onClick={handleAction} fullWidth variant='outlined'>
            Вернуть на доработку
        </Button>
    )
}

export default ReturnForRevisionBtn
